var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-cloud-color-wrapper" },
    [
      _c(
        "section",
        { staticClass: "section" },
        [
          _c("h6", [_vm._v("Words")]),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom" }),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            attrs: {
              "no-icon": "",
              type: "radio",
              wide: "",
              items: _setup.COLOR_MODES,
              disabled: _setup.disabled,
            },
            on: {
              input: function ($event) {
                return _setup.updateWordCloudConfig({
                  useImageColors: _setup.model.useImageColors,
                })
              },
            },
            model: {
              value: _setup.model.useImageColors,
              callback: function ($$v) {
                _vm.$set(_setup.model, "useImageColors", $$v)
              },
              expression: "model.useImageColors",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section" },
        [
          _c("h6", [_vm._v("Background")]),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom" }),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            attrs: {
              "no-icon": "",
              type: "radio",
              wide: "",
              items: _setup.BG_MODES,
              disabled: _setup.disabled,
            },
            on: { input: _setup.onBgModeChanged },
            model: {
              value: _setup.model.transparentBackground,
              callback: function ($$v) {
                _vm.$set(_setup.model, "transparentBackground", $$v)
              },
              expression: "model.transparentBackground",
            },
          }),
          _vm._v(" "),
          !_setup.model.transparentBackground && _setup.model.bgColor
            ? _c(
                "div",
                {
                  staticClass: "color-row border-gray-light rounded",
                  on: { click: _setup.toggleColorSelection },
                },
                [
                  _c("span", {
                    staticClass: "color-preview",
                    style: { backgroundColor: _setup.model.bgColor.hex },
                  }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_setup.model.bgColor.hex) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ColorSelector, {
        ref: "pickerRef",
        attrs: { open: _setup.clickOutsideActive, color: _setup.model.bgColor },
        on: {
          cancel: _setup.toggleColorSelection,
          "color-selected": _setup.onBgColorSelected,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }